<div class="d-block w-100">
  <ul class="list-unstyled" id="searchFields">
    <li>
      <div class="tab w-100">
        <a #batch
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == batch.id}"
          id="batchNumberFilter">
          Batch Number <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #name (click)="getTabContent($event)" [ngClass]="{'active':activeTab == name.id}" id="nameFilter">
          Batch Name <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #created
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == created.id}"
          id="createdFilter">
          Date Created <em class="dropdown-toggle" style="float: right"></em>
        </a>
        <a #totalRequests
          (click)="getTabContent($event)"
          [ngClass]="{'active':activeTab == totalRequests.id}"
          id="totalRequestsFilter">
          Total Requests <em class="dropdown-toggle" style="float: right"></em>
        </a>
      </div>
      <form [formGroup]="form">
        <div>
          @switch (activeTab) {
            @case (batch.id) {
              <div class="tabcontent">
                <input (input)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="batchNumber"
                  id="batchNumber"
                  onlyNumbers="true"
                  placeholder="Batch Number"
                  type="text"/>
              </div>
            }
            @case (name.id) {
              <div class="tabcontent">
                <input (input)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="batchName"
                  id="batchName"
                  placeholder="Batch Name"
                  type="text"/>
              </div>
            }
            @case (created.id) {
              <div class="tabcontent">
                <div class="date-input-group">
                  <label class="date-label" for="createdLower">From:</label>
                  <input (change)="setSearchCriteria($event)"
                    class="form-control d-inline"
                    formControlName="createdLower"
                    id="createdLower"
                    max="{{dateTimeCreatedUpper}}"
                    placeholder=""
                    type="date"
                    value="{{dateTimeCreatedLower}}"/>
                </div>
                <div class="date-input-group">
                  <label class="date-label" for="createdUpper">To:</label>
                  <input (change)="setSearchCriteria($event)"
                    class="form-control d-inline"
                    formControlName="createdUpper"
                    id="createdUpper"
                    min="{{dateTimeCreatedLower}}"
                    name="dpToDate"
                    placeholder=""
                    type="date"
                    value="{{dateTimeCreatedUpper}}"/>
                </div>
              </div>
            }
            @case (totalRequests.id) {
              <div class="tabcontent">
                <input (change)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="totalRequestsLower"
                  id="totalRequestsLower"
                  max="{{totalRequestsLower}}"
                  placeholder="Lower Limit"
                  type="number"/> <input (change)="setSearchCriteria($event)"
                  class="form-control"
                  formControlName="totalRequestsUpper"
                  id="totalRequestsUpper"
                  min="{{totalRequestsUpper}}"
                  placeholder="Upper Limit"
                  type="number"/>
              </div>
            }
          }
        </div>
        <div class="row">
          <div [hidden]="!tabActive" class="col-md-12 text-center">
            <button (click)="clear(activeTab)"
              [disabled]="disableClear(activeTab)"
              class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
              type="button">
              Clear
            </button>
            <button (click)="clearAll()"
              [disabled]="disableClearAll()"
              class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
              type="button">
              Clear All
            </button>
            <button (click)="search()"
              class="navy-btn btn-margin-left-right-5 btn-margin-top-bottom-10"
              type="submit">
              Update
            </button>
          </div>
        </div>
      </form>
    </li>
  </ul>
</div>